// K+
import GigyaManager from '../../api/GigyaManager';
import Constants from "../../api/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";

// Vendor
//import moment from 'moment';
import {useI18n} from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';
import moment from "moment";

export default {
    name: "homepage",
    components: {
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent
    },
    data() {
        return {
            promoApi: new PromoApi({
                endpoint: window.API_ENDPOINT + "/api/mulinobianco/2.0/web/promo-engine/",
                promoCode: Constants.API_PROMOCODE
            }),
            images: [
                {
                    "pid": "59542",
                    "imgPath": '2025/59542.jpg',
                    "selected": false
                },
                {
                    "pid": "92480",
                    "imgPath": '2025/92480.jpg',
                    "selected": false
                },
                {
                    "pid": "92506",
                    "imgPath": '2025/92506.jpg',
                    "selected": false
                },
                {
                    "pid": "162005",
                    "imgPath": '2025/162005.jpg',
                    "selected": false
                },
                {
                    "pid": "162013",
                    "imgPath": '2025/162013.jpg',
                    "selected": false
                },
                {
                    "pid": "162018",
                    "imgPath": '2025/162018.jpg',
                    "selected": false
                },
                {
                    "pid": "162084",
                    "imgPath": '2025/162084.jpg',
                    "selected": false
                },
                {
                    "pid": "162099",
                    "imgPath": '2025/162099.jpg',
                    "selected": false
                },
                {
                    "pid": "162100",
                    "imgPath": '2025/162100.jpg',
                    "selected": false
                },
                {
                    "pid": "162117",
                    "imgPath": '2025/162117.jpg',
                    "selected": false
                },
                {
                    "pid": "163144",
                    "imgPath": '2025/163144.jpg',
                    "selected": false
                },
                {
                    "pid": "170077",
                    "imgPath": '2025/170077.jpg',
                    "selected": false
                },
                {
                    "pid": "170103",
                    "imgPath": '2025/170103.jpg',
                    "selected": false
                },
                {
                    "pid": "464071",
                    "imgPath": '2025/464071.jpg',
                    "selected": false
                },
                {
                    "pid": "464077",
                    "imgPath": '2025/464077.jpg',
                    "selected": false
                },
                {
                    "pid": "746888",
                    "imgPath": '2025/746888.jpg',
                    "selected": false
                },
                {
                    "pid": "746895",
                    "imgPath": '2025/746895.jpg',
                    "selected": false
                },
                {
                    "pid": "746896",
                    "imgPath": '2025/746896.jpg',
                    "selected": false
                },
                {
                    "pid": "747405",
                    "imgPath": '2025/747405.jpg',
                    "selected": false
                },
                {
                    "pid": "751344",
                    "imgPath": '2025/751344.jpg',
                    "selected": false
                }
            ],
            chartPreviousYear: [
                {
                    pid: '92506',
                    imgPath: '2025/92506.jpg',
                    selected: false,
                    ranking: '1°'
                },
                {
                    pid: '162005',
                    imgPath: '2025/162005.jpg',
                    selected: false,
                    ranking: '2°'
                },
                {
                    pid: "751344",
                    imgPath: '2025/751344.jpg',
                    selected: false,
                    ranking: '3°'
                }
            ],
            currentPage: 1,
            maxImagesPerPage: 9,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const {t} = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return {t}
    },
    computed: {
        /**
         * Filter images by current page and max images per page
         * @returns Array
         */
        paginatedImages() {
            let imagesUnshuffled = this.images;
            const imagesShuffled = imagesUnshuffled
                .map((value) => ({value, sort: Math.random()}))
                .sort((a, b) => a.sort - b.sort)
                .map(({value}) => value)
            return imagesShuffled.slice(0, this.currentPage * this.maxImagesPerPage);
        },

        /**
         * Check if there are another images or not
         * @returns {boolean}
         */
        numberTotal() {
            return (this.currentPage * this.maxImagesPerPage) < this.images.length
        }
    },
    mounted() {
        this.checkContestActive();

        GigyaManager.getLoggedUserCached().then((u) => {
            this.userPrivacyProfiling = u.preferences.privacy_profiling.isConsentGranted;
            this.userLogged = true;
            this.promoApi.areaPersonale().then((result) => {
                const vote = result.body.response.data.votes[0];
                if (Object.keys(vote).length > 0) {
                    this.voted = true;
                    this.pidVoted = vote.voted_image;

                    let image = this.images.map(item => item.pid === vote.voted_image);
                    const imageIndex = image.indexOf(true);
                    if (imageIndex || imageIndex === 0) {
                        this.images[imageIndex].selected = true
                    }

                }
            });
        });


        /**
         * Listen vote event
         */
        this.emitter.on("vote", object => {
            let form = {
                basedata: {channelpid: 1},
                customdata: {}
            };

            form.customdata['user_profiling'] = this.userPrivacyProfiling ? 1 : 0;
            form.customdata['picture_code'] = object.pid;

            let objModal = {};

            if (this.voted) {
                const imgNode = this.images.filter(item => item.pid === this.pidVoted);
                // show modal voted
                objModal = {
                    isOpen: true,
                    pathImage: imgNode[0].imgPath,
                    title: this.t('modal.title.voteNotValid'),
                    description: this.t('modal.subtitle.voteNotValid'),
                    voted: true
                };

                // Emit event toggle-modal
                this.emitter.emit("toggle-modal", objModal);
            } else {

                this.promoApi.vota(form).then(() => {
                    const imgNode = this.images.filter(item => item.pid === object.pid);
                    // open modal with success result
                    objModal = {
                        isOpen: true,
                        pathImage: imgNode[0].imgPath,
                        title: this.t('modal.title.thankYou'),
                        description: this.t('modal.subtitle.thankYou'),
                        voted: true,
                        flag: true
                    };
                    this.emitter.emit("toggle-modal", objModal);

                    this.voted = true;
                    this.pidVoted = object.pid;

                    const image = this.images.map(item => item.pid === this.pidVoted);
                    const imageIndex = image.indexOf(true);
                    if (imageIndex || imageIndex === 0) {
                        this.images[imageIndex].selected = true
                    }

                    // add CH to user
                    GigyaManager.addCH(Constants.CH_PROMO);
                }).catch((error) => {

                    // fallback modal error
                    objModal = {
                        isOpen: true,
                        title: 'Ops, qualcosa è andato storto!',
                        description: error.body.status.errors.data.description,
                        voted: false
                    };
                    this.emitter.emit("toggle-modal", objModal);
                });
            }
        });
    },
    methods: {
        // update page and load more images
        loadMore() {
            this.currentPage += 1;
        },

        /**
         * Check if contest is active (true = active, false = inactive)
         * @returns {boolean}
         */
        checkContestActive() {
            this.promoApi.status().then((resp) => {
                console.log(resp)
                let response = resp.body.response.data;
                this.contestActive = moment(response.promo.dates.end.raw, 'YYYY-MM-DD HH:mm:ss').diff(moment()) > 0;
                //this.contestActive = true;
            });
        }
    }
}